import type { IcIcon } from "./types";

export const IcCheckbox: IcIcon = (properties) => (
  <svg
    focusable="false"
    height="10"
    viewBox="0 0 12 10"
    width="12"
    xmlns="http://www.w3.org/2000/svg"
    {...properties}
  >
    <path
      d="M4.707 9.711a.928.928 0 0 1-1.346 0L.28 6.52a1.006 1.006 0 0 1 0-1.39l.741-.77a.932.932 0 0 1 1.346 0l.995 1.033a.932.932 0 0 0 1.346 0L9.637.287a.93.93 0 0 1 1.342 0l.744.77a1.01 1.01 0 0 1 0 1.39L4.707 9.711z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
